import React, { createContext } from 'react';

const UsersTripsContext = createContext();

export default UsersTripsContext;